import { IAppState } from 'shared/common/state';

export function selectChatOnboarding(state: IAppState) {
  return state.chatOnboarding;
}
